/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { terminalApplicationsCreate } from "../../funcs/terminalApplicationsCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateTerminalApplication$inboundSchema,
};

export const tool$terminalApplicationsCreate: ToolDefinition<typeof args> = {
  name: "terminal-applications-create",
  description: `Create a new terminal application.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/terminal-applications.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await terminalApplicationsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
